import type { FC } from 'react'

import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from '@/components/ui/command.tsx'

type Props = {
  items: ComboboxItem[]
  selectedItems: ComboboxItem[]
  SearchResultItemComponent: FC<{ item: Member }>
  onSelect: (item: ComboboxItem) => void
  onRemove?: (item: ComboboxItem) => void
  placeholder?: string
  emptyMessage?: string
}

export const SearchSelectCommand = ({
  items,
  selectedItems,
  SearchResultItemComponent,
  onSelect,
  onRemove,
  placeholder,
  emptyMessage,
}: Props) => {
  return (
    <Command>
      {items.length > 0 && <CommandInput placeholder={placeholder} className="font-EN-KR-caption-regular h-10" />}
      <CommandList>
        <CommandEmpty className="font-EN-KR-caption-regular flex flex-col items-center justify-center h-10">
          {emptyMessage}
        </CommandEmpty>
        <CommandGroup className="p-0">
          {items.map((item) => (
            <CommandItem
              key={item.id}
              value={item.id}
              keywords={[item.name]}
              className="p-0"
              onSelect={(value) => {
                if (selectedItems.some((item) => item.id === value)) {
                  onRemove?.(item)
                } else {
                  onSelect(item)
                }
              }}
            >
              <SearchResultItemComponent item={item} />
            </CommandItem>
          ))}
        </CommandGroup>
      </CommandList>
    </Command>
  )
}
